// UI labels only. Offer identities, prices, limits and benefits come from the API.
export const foodCommercialPresentation = {
  title: "Fornecedor.net Food",
  headline: "Sua operação completa em um só lugar.",
  description: "Cardápio digital, pedidos, delivery, PDV e gestão do estabelecimento. Escolha a composição para a sua operação.",
  status: "Proposta comercial em análise",
  notice: "Preços, recursos e limites de usuários propostos. Contratação em preparação.",
  priceNotice: "Valor mensal proposto",
  annualPriceNotice: "Valor anual proposto",
  periodNotice: "Referência mensal. Anual e outras periodicidades em definição.",
  actionLabel: "Em preparação",
  terms: ["Sem comissão de marketplace no canal próprio", "Sem cobrança por pedido direto", "Sem limite comercial de pedidos"],
} as const;
